import React, { useState, useEffect } from "react";
import { TabContent, TabPane } from "reactstrap";
import { TERMS_CONDITIONS_REQUEST } from "containers/csboard/Action";
import InformPrevTerms from "components/csboard/InformPrevTerms";

import { useSelector, useDispatch } from "react-redux";
import classnames from "classnames";

const Inform_list = (props) => {
    const { userId, reloadState, mode } = props;
    const dispatch = useDispatch();

    const [activeTab, setActiveTab] = useState("1");
    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    const termsInfo = useSelector((state) => state.csboardReducer.termsInfo);

    // CK 에디터 마크업에서 스타일 속성을 제거하는 함수
    const removeInlineStyles = (htmlString) => {
        if (!htmlString) return "";
        return htmlString.replace(/style="[^"]*"/gi, "");
    };

    useEffect(() => {
        if (reloadState === "3") setActiveTab("1");
    }, [reloadState]);

    useEffect(() => {
        switch (activeTab) {
            case "2":
                dispatch(
                    TERMS_CONDITIONS_REQUEST({
                        headerParam: userId,
                        //userSeq : userSeq,
                        dvsn_cd: "MMBRTERMS",
                    }),
                );
                break;
            case "3":
                dispatch(
                    TERMS_CONDITIONS_REQUEST({
                        headerParam: userId,
                        //userSeq : userSeq,
                        dvsn_cd: "CPYTERMS",
                    }),
                );
                break;
            default:
                dispatch(
                    TERMS_CONDITIONS_REQUEST({
                        headerParam: userId,
                        //userSeq : userSeq,
                        dvsn_cd: "SVCTERMS",
                    }),
                );
                break;
        }
    }, [activeTab]);

    return (
        <>
            <div className="NoticeList position-relative">
                <div className="undertab_tabs clear">
                    <div className="fl left-tabs">
                        <button
                            type="button"
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => {
                                toggle("1");
                            }}
                        >
                            이용약관
                        </button>
                        <button
                            type="button"
                            className={classnames({ active: activeTab === "2" })}
                            onClick={() => {
                                toggle("2");
                            }}
                        >
                            개인정보 처리방침
                        </button>
                        <button
                            type="button"
                            className={classnames({ active: activeTab === "3" })}
                            onClick={() => {
                                toggle("3");
                            }}
                        >
                            저작권 정책
                        </button>
                    </div>
                </div>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <div className="inform-text_wrap">
                            <div className="inform-text">
                                <pre style={mode ? { color: "black" } : { color: "white" }}>
                                    <div dangerouslySetInnerHTML={{ __html: termsInfo.TERMS_CNTT }}></div>
                                </pre>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tabId="2">
                        <div className="inform-text_wrap">
                            <div className="inform-text">
                                <pre style={mode ? { color: "black" } : { color: "white" }}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: removeInlineStyles(termsInfo.TERMS_CNTT),
                                        }}
                                    ></div>
                                </pre>
                                {/* 이전 약관 보기 */}
                                <InformPrevTerms />
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tabId="3">
                        <div className="inform-text_wrap">
                            <div className="inform-text">
                                <pre style={mode ? { color: "black" } : { color: "white" }}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: removeInlineStyles(termsInfo.TERMS_CNTT),
                                        }}
                                    ></div>
                                </pre>
                            </div>
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        </>
    );
};

export default Inform_list;
